/// <reference path="../../app.definition.ts" />


import angular from "angular";
import { Serializable } from "./Serializable";
import { User } from "./user";
import { Subject } from "./subject";
import { ServiceTemplateOptions } from "./serviceTemplateOptions";
import { ServiceNote } from "./serviceNote";
import { Util } from "@common/util";

export class Service implements Serializable<Service> {

    serviceType: String;
    providers: User[] = [];
    assignedUsers: User[] = [];
    recipients: Subject[] = [];
    assignedSubjects: Subject[] = [];
    assignor: User;
    title: String;
    serviceId;
    assignedServiceId;
    serviceCode;
    recipient: Subject;
    providerType;
    settingId;
    setting;
    startDate;
    endDate;
    endDateDisplay;
    frequency;
    duration;
    format;
    groupSize;
    serviceTemplateOptions: ServiceTemplateOptions[] = [];
    origFrequency;
    durationUnitId;
    unit;
    unitAbbr;
    canEditService: boolean;
    canShareService: boolean;
    isCurrentUserProvider: boolean;
    isServiceClosed: boolean = false;
    serviceNotes: ServiceNote[] = [];
    formatValue: string;
    forms: any;
    assignorId;
    teamPartyId;

    public processServiceOptions() {
        for (var i = 0; !!this.serviceTemplateOptions && i < this.serviceTemplateOptions.length; i++) {
            switch (this.serviceTemplateOptions[i].optionId) {
                case -1:
                    this.origFrequency = this.serviceTemplateOptions[i].value;
                    break;
                case -2:
                    this.duration = this.serviceTemplateOptions[i].value;
                    this.durationUnitId = this.serviceTemplateOptions[i].unitId;
                    this.unitAbbr = this.serviceTemplateOptions[i].value;
                    break;
                case -3:
                    this.setting = this.serviceTemplateOptions[i].value;
                    break;
                case -4:
                    this.startDate = Util.getNonUTCDate(parseFloat(this.serviceTemplateOptions[i].value));
                    break;
                case -5:
                    if (this.serviceTemplateOptions[i].value) {
                        this.endDateDisplay = Util.getNonUTCDate(parseFloat(this.serviceTemplateOptions[i].value));
                        this.endDate = this.endDateDisplay;
                    } else {
                        this.endDateDisplay = "";
                        this.endDate = null;
                    }
                    break;
                case -6:
                case -7:
                case -8:
                case -9:
                case -10:
                case -11:
                case -12:
                case -13:
                    if (this.serviceTemplateOptions[i].value) {
                        const isValidDate = !isNaN(Date.parse(this.serviceTemplateOptions[i].value));
                        if (!isValidDate) {
                            this.serviceTemplateOptions[i].value = new Date(parseFloat(this.serviceTemplateOptions[i].value)).toLocaleDateString('en-US');
                        }
                    }
                    break;
                default:
                    break;
            }
            if (this.serviceTemplateOptions[i].optionLabel.toLowerCase() == "format") {
                this.formatValue = this.serviceTemplateOptions[i].value;
            }
            if (this.serviceTemplateOptions[i].optionLabel.toLowerCase() == "group size") {
                this.groupSize = this.serviceTemplateOptions[i].value;
            }
        }
        if (!!this.origFrequency && !!this.duration) {
            this.frequency = this.origFrequency + " time(s)";
        }
        if (!!this.formatValue) {
            if (this.formatValue.toLowerCase() == "group" && !!this.groupSize) {
                this.format = this.formatValue + " " + this.groupSize;
            } else if (this.formatValue.toLowerCase() == "individual") {
                !!this.recipients && this.recipients.length > 0 && (this.recipient = new Subject().deserialize(this.recipients[0]));
            }
        }
    }


    // this will be used for casting JSON to object
    deserialize(input) {

        //input.serivceName && (this.name = input.serivceName);
        //input._id && (this.serviceId = input._id);
        // input.providerId && ( this.providerId = input.provider ) ;
        // input.designation && (this.designation = input.designation );
        // input.comment && ( this.comment = input.comment);



        input.recipient && (this.recipient = new Subject().deserialize(input.recipient));
        input.serviceId && (this.serviceId = input.serviceId);
        input.assignorId && (this.assignorId = input.assignorId);
        input.assignedServiceId && (this.assignedServiceId = input.assignedServiceId);
        input.serviceCode && (this.serviceCode = input.serviceCode);
        input.code && (this.serviceCode = input.code);
        input.serviceType && (this.serviceType = input.serviceType);
        input.serviceTypeValue && (this.serviceType = input.serviceTypeValue);
        input.serviceTypeLabel && (this.serviceType = input.serviceTypeLabel);
        input.serviceTypeValue && (this.title = input.serviceTypeValue);
        input.providerType && (this.providerType = input.providerType);
        input.providerTypeValue && (this.providerType = input.providerTypeValue);
        input.roleName && (this.providerType = input.roleName);
        input.frequency && (this.frequency = input.frequency);
        input.duration && (this.duration = input.duration);
        input.settingId && (this.settingId = input.settingId);
        input.setting && (this.setting = input.setting);
        input.startDate && (this.startDate = Util.getNonUTCDate(parseFloat(input.startDate)));
        input.endDate && (this.endDate = Util.getNonUTCDate(parseFloat(input.endDate)));
        input.endDateDisplay && (this.endDateDisplay = new Date(parseInt(input.endDateDisplay)));
        input.canEditService && (this.canEditService = input.canEditService);
        input.canShareService && (this.canShareService = input.canShareService);
        input.isCurrentUserProvider && (this.isCurrentUserProvider = input.isCurrentUserProvider);
        input.serviceClosed && (this.isServiceClosed = input.serviceClosed);
        !!input.status && input.status == 'COMPLETED' && (this.isServiceClosed = true);
        input.formatValue && (this.formatValue = input.formatValue);
        input.forms && (this.forms = input.forms);
        input.teamPartyId && (this.teamPartyId = input.teamPartyId);


        for (var i = 0; !!input.assignedUsers && i < input.assignedUsers.length; i++) {
            if (input.assignedUsers[i].serviceRole == "PROVIDER") {
                this.providers.push(new User().deserialize(input.assignedUsers[i]));
            }
            else if (input.assignedUsers[i].serviceRole == "ASSIGNOR") {
                this.assignor = new User().deserialize(input.assignedUsers[i]);
            }
        }

        for (var i = 0; !!input.assignedSubjects && i < input.assignedSubjects.length; i++) {
            this.recipients.push(new Subject().deserialize(input.assignedSubjects[i]));
        }

        for (var i = 0; !!input.assignedUsers && i < input.assignedUsers.length; i++) {
            this.assignedUsers.push(new User().deserialize(input.assignedUsers[i]));
        }

        for (var i = 0; !!input.assignedSubjects && i < input.assignedSubjects.length; i++) {
            this.assignedSubjects.push(new Subject().deserialize(input.assignedSubjects[i]));
        }

        for (var i = 0; !!input.serviceTemplateOptions && i < input.serviceTemplateOptions.length; i++) {
            this.serviceTemplateOptions.push(new ServiceTemplateOptions().deserialize(input.serviceTemplateOptions[i]));
        }

        for (var i = 0; !!input.serviceNotes && i < input.serviceNotes.length; i++) {
            this.serviceNotes.push(new ServiceNote().deserialize(input.serviceNotes[i]));
        }

        this.processServiceOptions();
        return this;
    }

    constructor() {
        // The below data is test data
    }

}

/**
 * Created by szaman on 2/25/2016.
 */
